import type { ProcessType } from 'shared/domain/process/types/model';
import type { EntityCollectionActions } from '../entityCollection';
import type { StoreData, ActionsState, DataActions, AsyncAction } from '../types';

export const processActionNames = ['updateWorkflow'] as const;

export type ProcessActionName = (typeof processActionNames)[number];

export type ProcessActions = DataActions<ProcessType> & EntityCollectionActions<ProcessType>;

export type ProcessAsyncActions = {
  /** Resolves with the process the server saved; rejects with its error. */
  updateWorkflow: (
    processId: string,
    workflowId: string,
    projectId: string
  ) => Promise<ProcessType>;
};

export type ProcessStore = {
  data: StoreData<ProcessType>;
  /** True once a complete list arrived (also an empty one). */
  isReady: boolean;
  actions: ProcessActions;
  asyncActions: ProcessAsyncActions;
  _actionStates: ActionsState<ProcessActionName>;
};

export type UseProcessesResult = {
  processes: ProcessType[];
  loading: boolean;
  isReady: boolean;
  updateWorkflow: AsyncAction<
    [processId: string, workflowId: string, projectId: string],
    ProcessType
  >;
};
